import React from "react";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import moment from "moment";

import PdfFileItem from "@/react-components/PdfFileItem";
import { libraryTypeEnum } from "@/utils/enum";

class NewsReleaseListItem extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="news-release-list-item-container">
        <div className="news-release-list-item-container-date">
          {moment(data.updateDate || data.createDate).format("YYYY.MM.DD")}
        </div>
        <div className="news-release-list-item-container-category">
          {data.category}
        </div>
        {data.libraryType === libraryTypeEnum.pdf ? (
          <PdfFileItem
            pdfFile={data.pdfFile}
            pdfTitle={data.title}
            className="news-release-list-item-container-title"
            libraryType={data.libraryType}
            isDownload
          />
        ) : (
          <RouterLink
            className="news-release-list-item-container-title"
            to={data.linkUrl}
          >
            {data.title}
          </RouterLink>
        )}
      </div>
    );
  }
}

NewsReleaseListItem.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    updateDate: PropTypes.string,
    createDate: PropTypes.string,
    category: PropTypes.string.isRequired,
    libraryType: PropTypes.string.isRequired,
    linkUrl: PropTypes.string,
    pdfFile: PropTypes.string,
  }).isRequired,
};

export default NewsReleaseListItem;
